import { useTranslation } from 'react-i18next';

const SummaryBar = ({ summary }) => {
  const { t } = useTranslation();

  if (!summary) return null;

  const tiles = [
    {
      label: t('admin.reporting.webhooks.summary.total'),
      value: summary.total ?? '—',
      color: 'text-[#334155]',
      bg: 'bg-[#F8FAFC] border-[#E2E8F0]',
    },
    {
      label: t('admin.reporting.webhooks.summary.success'),
      value: summary.success ?? '—',
      color: 'text-[#16A34A]',
      bg: 'bg-[#F0FDF4] border-[#BBF7D0]',
    },
    {
      label: t('admin.reporting.webhooks.summary.failed'),
      value: summary.failed ?? '—',
      color: 'text-[#E11D48]',
      bg: 'bg-[#FFF1F2] border-[#FECDD3]',
    },
    {
      label: t('admin.reporting.webhooks.summary.processing'),
      value: summary.processing ?? summary.pending ?? '—',
      color: 'text-[#CA8A04]',
      bg: 'bg-[#FEFCE8] border-[#FEF08A]',
    },
    {
      label: t('admin.reporting.webhooks.summary.successRate'),
      value:
        summary.total > 0
          ? `${((summary.success / summary.total) * 100).toFixed(1)}%`
          : '—',
      color: 'text-[#1D4ED8]',
      bg: 'bg-[#EFF6FF] border-[#BFDBFE]',
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 mb-4">
      {tiles.map((tile) => (
        <div key={tile.label} className={`rounded-xl border px-3 py-3 ${tile.bg}`}>
          <p className="text-[10px] font-semibold text-[#7989A0] uppercase tracking-wide mb-1 truncate">
            {tile.label}
          </p>
          <p className={`text-[20px] font-bold leading-none ${tile.color}`}>{tile.value}</p>
        </div>
      ))}
    </div>
  );
};

export default SummaryBar;
